export default __webpack_public_path__ + "static/media/regulatory--pass-with-care--g1.75f3b466.png";